import React, { Component } from 'react';
import {  BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';

import Menu from "./components/Menu";
import Island from "./components/Island";
import Characters from "./components/Characters";
import Box from "./components/Box";
import Joe from "./components/Joe";
import Timeline from "./components/Timeline";
import Rumors from "./components/Rumors";
import Setting from "./components/Setting";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle)

class App extends Component {
	
	render() {
		return (
		<Router>
			<div className="App">
				<div className="AppTitle">Les Ruines d'Engorath</div>
				<Menu />
				<Route path="/edit/:key" component={Island} />
				<Route exact path="/" component={Island} />
				<Route exact path="/personnages" component={Characters} />
				<Route exact path="/boite" component={Box} />
				<Route exact path="/chezjoe" component={Joe} />
				<Route exact path="/historique" component={Timeline} />
				<Route exact path="/rumeurs" component={Rumors} />
				<Route exact path="/univers" component={Setting} />
				
				<Route path="/engorath/edit/:key" component={Island} />
				<Route exact path="/engorath" component={Island} />
				<Route exact path="/engorath/personnages" component={Characters} />
				<Route exact path="/engorath/boite" component={Box} />
				<Route exact path="/engorath/chezjoe" component={Joe} />
				<Route exact path="/engorath/historique" component={Timeline} />
				<Route exact path="/engorath/rumeurs" component={Rumors} />
				<Route exact path="/engorath/univers" component={Setting} />
			</div>
		</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js